import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import SpecTable from 'components/Products/IN-Motion/300/SpecTable';
import ComponentTable from 'components/Products/IN-Motion/300/ComponentTable';
import NavButtons from 'components/Products/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  SpecTable,
  ComponentTable,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};